export const radioButtonTheme = {
  root: {
    width: 'var(--check-radio-dimension)',
    height: 'var(--check-radio-dimension)',
    transitionDuration: '0.2s',
    focusRing: {
      offset: 'var(--reset)',
      width: 'var(--reset)',
      shadow: 'var(--focus-ring)',
    },
  },
  icon: {
    size: 'var(--radio-icon-dimension)',
  },
  extend: {
    agility: {
      unfilled: {
        disabled: {
          background: 'var(--p-surface-300)',
          border: {
            color: 'var(--p-surface-100)',
          },
        },
      },
    },
    colorScheme: {
      dark: {
        agility: {
          unfilled: {
            disabled: {
              background: 'var(--p-surface-900)',
              border: {
                color: 'var(--p-surface-800)',
              },
            },
          },
        },
      },
    },
  },
  colorScheme: {
    light: {
      root: {
        background: 'var(--p-white)',
        borderColor: 'var(--text-color-secondary)',
        hoverBorderColor: 'var(--p-primary-500)',
        checkedBorderColor: 'var(--p-primary-500)',
        checkedHoverBackground: 'var(--p-primary-500)',
        checkedHoverBorderColor: 'var(--p-primary-500)',
        checkedDisabledBorderColor: 'var(--p-surface-500)',
        filledBackground: 'var(--p-primary-500)',
        disabledBackground: 'var(--p-surface-500)',
        focusRing: {
          color: 'var(--p-primary-500)',
        },
      },
      icon: {
        checkedColor: 'var(--p-white)',
        checkedHoverColor: 'var(--p-white)',
        disabledColor: 'var(--p-white)',
      },
    },
    dark: {
      root: {
        background: 'var(--transparent)',
        borderColor: 'var(--p-surface-700)',
        hoverBorderColor: 'var(--p-primary-500)',
        checkedBorderColor: 'var(--p-primary-500)',
        checkedHoverBackground: 'var(--p-primary-500)',
        checkedHoverBorderColor: 'var(--p-primary-500)',
        checkedDisabledBorderColor: 'var(--p-surface-500)',
        filledBackground: 'var(--p-primary-500)',
        disabledBackground: 'var(--p-surface-500)',
        focusRing: {
          color: 'var(--p-primary-500)',
        },
      },
      icon: {
        checkedColor: 'var(--p-white)',
        checkedHoverColor: 'var(--p-white)',
        disabledColor: 'var(--p-white)',
      },
    },
  },
  css: ({ dt }: any) => `
    .p-radiobutton.p-disabled:not(.p-radiobutton-checked) .p-radiobutton-box {
      background: ${dt('radiobutton.agility.unfilled.disabled.background')} !important;
      border-color: ${dt('radiobutton.agility.unfilled.disabled.border.color')} !important;
    }
  `,
};
